<template>
  <div class="action-config h-full overflow-hidden relative" >
    <categoryTitle class="mt-10px" title="操作设定" />
    <div class="my-5px settings-wrap">
      <div class="settings-wrap-item flex items-center my-5px">
        <div class="axis-name">X</div>
        <div class="axis-name">Y</div>
        <div class="axis-name">Z</div>
      </div>
      <div class="settings-wrap-item flex items-center my-5px">
        <el-input
         class="mr-5px"
          size="small"
          v-model="settigOptions.xPosition"
          clearable
        ></el-input>
        <el-input
        class="mr-5px"
          size="small"
          v-model="settigOptions.yPosition"
          clearable
        ></el-input>
        <el-input
        class="mr-5px"
          size="small"
          v-model="settigOptions.zPosition"
          clearable
        ></el-input>
        <el-button
          type="primary"
          size="small"
          @click="insertMove"
          >插入移动</el-button>
      </div>
      <div class="settings-wrap-item flex items-center my-10px">
        <el-input
         class="mr-5px"
          size="small"
          v-model="settigOptions.xRotation"
          clearable
        ></el-input>
        <el-input
        class="mr-5px"
          size="small"
          v-model="settigOptions.yRotation"
          clearable
        ></el-input>
        <el-input
        class="mr-5px"
          size="small"
          v-model="settigOptions.zRotation"
          clearable
        ></el-input>
        <el-button
          type="primary"
          size="small"
          @click="insertRotation"
          >插入旋转</el-button>
      </div>
      <el-button
          type="primary"
          size="small"
          @click="startEdit('move')"
          >开始操作</el-button>
      <el-button
          type="primary"
          size="small"
          @click="editNode(1)"
          :disabled="!isStartEdit"
          >移动</el-button>
      <el-button
        type="primary"
        size="small"
        @click="editNode(2)"
        :disabled="!isStartEdit"
        >旋转</el-button>
    </div>
    <categoryTitle class="mt-10px" title="操作列表" />
    <div class="flex items-center settings-wrap my-5px">
      <el-input
        size="small"
        v-model="keyWord"
        placeholder="请输入关键词"
        clearable
        @keypress.native.enter="searchList"
        @clear="searchList"
      >
      <i @click="searchList" slot="suffix" class="el-input__icon el-icon-search"></i>
    </el-input>
      <el-button @click="batchDelHandle" size="small" type="primary" class="ml-10px">批量删除</el-button>
    </div>
    <el-table
      :data="tableData"
      ref="multipleTable"
      :height="`calc(50%)`"
      class="settings-table"
      highlight-current-row
      row-key="id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="no" width="55" label="序号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="actionDesc" label="动作描述" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="55">
        <template slot-scope="{ row }">
          <span @click="delHandle(row)" size="small" class="text-[#44F1FF] cursor-pointer"
            >删除</span
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      small
      class="mt-5px flex justify-end"
      background
      @current-change="getTableData"
      :current-page="pageNo"
      :page-size="pageSize"
      layout="total, prev, pager, next"
      :total="total"
      :pager-count="5"
      popper-class="visualization-select-popper"
    >
    </el-pagination>
    <div class="bottom-content fixed bottom-6 right-10 flex items-center justify-around">
      <el-input
        size="small"
        v-model="playSpeed"
        placeholder="速度"
        clearable
        @keypress.native.enter="changeTimeScale"
      >
      </el-input>
      <!-- <el-button @click="animationStop" size="small" type="primary" class="ml-10px">停止</el-button>
      <el-button @click="animationPlay" size="small" type="primary" class="ml-10px">播放</el-button> -->

      <el-button @click="goCheck" size="small" type="primary" class="ml-10px">去检查</el-button>
      <el-button v-if="!isStop" @click="actionPreview" size="small" type="primary" class="ml-10px">预览动作</el-button>
      <el-button v-else @click="animationStop" size="small" type="primary" class="ml-10px">停止</el-button>
  </div>
  </div>
</template>

<script>
import categoryTitle from '@/components/cockpit/CategoryTitle'

export default {
  name: 'ActionConfig',
  components: {
    categoryTitle,
  },
  props: {
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    transferProps: {
      type: Object,
      defalut: {},
    },
  },
  data() {
    return {
      originalData: {
        xPosition: 0,
        yPosition: 0,
        zPosition: 0,
        xRotation: 0,
        yRotation: 0,
        zRotation: 0
      },
      settigOptions: {
        xPosition: 0,
        yPosition: 0,
        zPosition: 0,
        xRotation: 0,
        yRotation: 0,
        zRotation: 0
      },
      pageNo: 1,
      pageSize: 15,
      total: 0,
      keyWord: '',
      tableData: [
        {
          pos: [0, 0, 0],
          no: 1,
          keyframeTime: 0,
          actionDesc: 'X移动0米,Y移动0米,Z移动0米'
        },
        {
          rot: [1, 0, 0, 0],
          no: 2,
          keyframeTime: 1,
          actionDesc: 'X旋转0度,Y旋转0度,Z旋转0度',
        }
      ],
      activeNode: 0,
      objectNode: 0,
      isStartEdit: false,
      aniAction: null,
      keyframeTime: 2,
      mixer: null,
      clip: null,
      pathList: [],
      moveActionDesc: '',
      rotationActionDesc: '',
      playSpeed: 1,
      currentRow: null,
      selectedRows: [],
      lastSelectedIndex: -1,
      isStop: false,
    }
  },
  created() {
    this.activeNode = this.transferProps.subjectNode
    this.objectNode = this.transferProps.objectNode
    this.getNodePosRoat(true)
  },
  mounted() {
    // 初始化序号
    this.updateSerialNumbers()
  },
  methods: {
    // 更新序号
    updateSerialNumbers() {
      this.tableData.forEach((row, index) => {
        row.no = index + 1
      })
    },
    // 重新计算keyframeTime
    recalculateKeyframeTimes(startIndex) {
      for (let i = startIndex; i < this.tableData.length; i++) {
        this.tableData[i].keyframeTime = this.tableData[i - 1].keyframeTime + 1
      }
    },
    async insertMove() {
      // await this.player.Native.Node.removeNodeFromAxisEdit(this.activeNode)
      const nodeInfo = await this.player.Native.Node.getProperty(this.activeNode, ['name', 'code', 'localTrans', 'localRot'])
      const xDis = this.settigOptions.xPosition - this.originalData.xPosition
      const yDis = this.settigOptions.yPosition - this.originalData.yPosition
      const zDis = this.settigOptions.zPosition - this.originalData.zPosition
      this.moveActionDesc = `X移动${xDis.toFixed(2)}米,Y移动${yDis.toFixed(2)}米,Z移动${zDis.toFixed(2)}米`

      let insertIndex = this.lastSelectedIndex
      let baseKeyframeTime = 0
      if (insertIndex >= 0) {
        // 在选中行后面插入
        baseKeyframeTime = this.tableData[insertIndex].keyframeTime
        insertIndex += 1 // 插入到选中行的后面
      } else {
        // 如果没有选中行，则插入到最后
        insertIndex = this.tableData.length
        if (insertIndex > 0) {
          baseKeyframeTime = this.tableData[insertIndex - 1].keyframeTime
        }
      }
      const newLocalTrans = nodeInfo.localTrans.map((num) => { return parseFloat(num.toFixed(2)) })
      const data = {
        xPosition: newLocalTrans[0],
        yPosition: newLocalTrans[1],
        zPosition: newLocalTrans[2],
        pos: nodeInfo.localTrans,
        no: insertIndex + 1,
        keyframeTime: baseKeyframeTime + 1,
        actionDesc: this.moveActionDesc
      }
      // 插入新行
      this.tableData.splice(insertIndex, 0, data)
      // 重新计算后面所有行的keyframeTime
      this.recalculateKeyframeTimes(insertIndex + 1)
      // 更新序号
      this.updateSerialNumbers()
      // 清空选择（可选）
      this.$refs.multipleTable.clearSelection()
      this.selectedRows = []
      this.lastSelectedIndex = -1
    },
    async insertRotation() {
      // await this.player.Native.Node.removeNodeFromAxisEdit(this.activeNode)
      const nodeInfo = await this.player.Native.Node.getProperty(this.activeNode, ['name', 'code', 'localTrans', 'localRot'])
      const xRot = this.originalData.xRotation - this.settigOptions.xRotation
      const yRot = this.originalData.yRotation - this.settigOptions.yRotation
      const zRot = this.originalData.zRotation - this.settigOptions.zRotation
      this.rotationActionDesc = `X旋转${xRot.toFixed(2)}度,Y旋转${yRot.toFixed(2)}度,Z旋转${zRot.toFixed(2)}度`
      let insertIndex = this.lastSelectedIndex
      let baseKeyframeTime = 0
      if (insertIndex >= 0) {
        // 在选中行后面插入
        baseKeyframeTime = this.tableData[insertIndex].keyframeTime
        insertIndex += 1 // 插入到选中行的后面
      } else {
        // 如果没有选中行，则插入到最后
        insertIndex = this.tableData.length
        if (insertIndex > 0) {
          baseKeyframeTime = this.tableData[insertIndex - 1].keyframeTime
        }
      }
      const newLocalRot = nodeInfo.localRot.map((num) => { return parseFloat(num.toFixed(2)) })
      const data = {
        xRotation: newLocalRot[0],
        yRotation: newLocalRot[1],
        zRotation: newLocalRot[2],
        wRotation: newLocalRot[3],
        rot: nodeInfo.localRot,
        no: insertIndex + 1,
        keyframeTime: baseKeyframeTime + 1,
        actionDesc: this.rotationActionDesc
      }
      // 插入新行
      this.tableData.splice(insertIndex, 0, data)
      // 重新计算后面所有行的keyframeTime
      this.recalculateKeyframeTimes(insertIndex + 1)
      // 更新序号
      this.updateSerialNumbers()
      // 清空选择（可选）
      this.$refs.multipleTable.clearSelection()
      this.selectedRows = []
      this.lastSelectedIndex = -1
    },
    delHandle(row) {
      const index = this.tableData.indexOf(row)
      this.tableData.splice(index, 1)
      // 重新计算keyframeTime（从0开始）
      this.tableData.forEach((item, idx) => {
        item.keyframeTime = idx
      })

      // 更新序号
      this.updateSerialNumbers()

      // 如果删除的是选中的行，更新选中状态
      this.updateSelectionAfterDelete(index)
    },
    // 删除行后更新选中状态
    updateSelectionAfterDelete(deletedIndex) {
      // 从选中行数组中移除被删除的行
      this.selectedRows = this.selectedRows.filter((row) => {
        const rowIndex = this.tableData.indexOf(row)
        return rowIndex !== -1 // 只保留仍然存在的行
      })

      // 更新最后选中的索引
      if (this.selectedRows.length > 0) {
        const lastSelected = this.selectedRows[this.selectedRows.length - 1]
        this.lastSelectedIndex = this.tableData.findIndex((item) => { return item === lastSelected })
      } else {
        this.lastSelectedIndex = -1
      }
      // 更新表格的选中状态
      this.$nextTick(() => {
        this.$refs.multipleTable.clearSelection()
        this.selectedRows.forEach((row) => {
          const rowIndex = this.tableData.indexOf(row)
          if (rowIndex !== -1) {
            this.$refs.multipleTable.toggleRowSelection(this.tableData[rowIndex], true)
          }
        })
      })
    },
    searchList() {

    },
    getTableData() {
    },
    handleSelectionChange(e) {
      this.selectedRows = e
      if (e.length > 0) {
        const index = e.length - 1
        const lastSelected = e[index]
        this.lastSelectedIndex = this.tableData.findIndex((item) => { return item === lastSelected })
      } else {
        this.lastSelectedIndex = -1
      }
    },
    batchDelHandle() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要删除的行')
        return
      }

      // 获取要删除的索引（从后往前删除，避免索引变化）
      const indicesToDelete = this.selectedRows
        .map((row) => { return this.tableData.indexOf(row) })
        .sort((a, b) => { return b - a }) // 降序排列

      // 删除行
      indicesToDelete.forEach((index) => {
        this.tableData.splice(index, 1)
      })

      // 重新计算keyframeTime（从0开始）
      this.tableData.forEach((row, index) => {
        row.keyframeTime = index
      })

      // 更新序号
      this.updateSerialNumbers()

      // 清空选择
      this.$refs.multipleTable.clearSelection()
      this.selectedRows = []
      this.lastSelectedIndex = -1
    },
    async animationStop() {
      this.isStop = !this.isStop
      await this.player.Native.AnimationAction.stop(this.aniAction)
      await this.player.Native.AnimationMixer.applyTime(this.mixer, 0, true)
    },
    async animationPlay() {
      await this.player.Native.AnimationAction.play(this.aniAction)
    },
    async actionPreview() {
      this.isStop = !this.isStop
      // this.tableData.sort((a, b) => { return a.time - b.time })
      await this.player.Native.Node.removeNodeFromAxisEdit(this.activeNode)
      if (this.mixer) await this.player.Native.AnimationMixer.removeMixer(this.mixer)
      if (!this.mixer && !this.clip) {
        this.mixer = await this.player.Native.AnimationMixer.getMixer('move')
        this.clip = await this.player.Native.AnimationClip.getClip(this.mixer, 'move')
      }
      const pathList = this.tableData.sort((a, b) => { return a.keyframeTime - b.keyframeTime })
      // 创建路径动画混合器
      const trackT = await this.player.Native.KeyframeTrack.addTrackWithParam(this.clip, this.activeNode, {
        name: `trackLocalTranslation${this.activeNode}`,
        trackType: 3,
        propertyLinkType: 1
      })
      const trackR = await this.player.Native.KeyframeTrack.addTrackWithParam(this.clip, this.activeNode, {
        name: `trackLocalRotation${this.activeNode}`,
        trackType: 5,
        propertyLinkType: 2
      })
      // 添加位置关键帧
      for (let i = 0; i < pathList.length; i++) {
        const item = pathList[i]
        if (item.pos && item.pos.length > 0) {
          await this.player.Native.KeyframeTrack.keyAppend(trackT, item.keyframeTime, item.pos)
        }
        if (item.rot && item.rot.length > 0) {
          await this.player.Native.KeyframeTrack.keyAppend(trackR, item.keyframeTime, item.rot)
        }
      }
      this.aniAction = await this.player.Native.AnimationAction.clipAction(this.mixer, this.clip)
      // 设置为循环模式播放
      await this.player.Native.AnimationAction.setLoop(this.aniAction, 1, -1)
      await this.player.Native.AnimationAction.play(this.aniAction)
    },
    async goCheck() {
      if (this.aniAction && this.mixer) {
        if (this.isStop) {
          await this.player.Native.AnimationAction.stop(this.aniAction)
        }
        await this.player.Native.AnimationMixer.applyTime(this.mixer, 0, true)
      }
      const durationTime = await this.player.Native.AnimationClip.durationTime(this.clip)
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: { code: 'NewCollisionCheck', origin: 'ActionConfig', name: '新建碰撞检查' },
          position: 'right',
          type: 'tags',
          props: {
            subjectNode: this.transferProps.subjectNode,
            objectNode: this.transferProps.objectNode,
            actions: this.tableData,
            actionTime: durationTime,
            aniAction: this.aniAction,
            mixer: this.mixer,
            collisionType: 1// 动态碰撞
          }
        },
      })
      window.dispatchEvent(openEvent)
    },
    // 动画速度调节
    async changeTimeScale() {
      await this.player.Native.AnimationAction.setTimeScale(this.aniAction, this.playSpeed)
    },
    // 四元数转欧拉角函数
    quaternionToEuler(qw, qx, qy, qz) {
      // 归一化四元数
      const length = Math.sqrt(qw * qw + qx * qx + qy * qy + qz * qz)
      if (length === 0) return { x: 0, y: 0, z: 0 }

      const nw = qw / length
      const nx = qx / length
      const ny = qy / length
      const nz = qz / length

      // 计算欧拉角（弧度）
      // 横滚 (x)
      const sinr_cosp = 2 * (nw * nx + ny * nz)
      const cosr_cosp = 1 - 2 * (nx * nx + ny * ny)
      const roll = Math.atan2(sinr_cosp, cosr_cosp)

      // 俯仰 (y)
      const sinp = 2 * (nw * ny - nz * nx)
      let pitch
      if (Math.abs(sinp) >= 1) {
        pitch = Math.sign(sinp) * Math.PI / 2
      } else {
        pitch = Math.asin(sinp)
      }

      // 偏航 (z)
      const siny_cosp = 2 * (nw * nz + nx * ny)
      const cosy_cosp = 1 - 2 * (ny * ny + nz * nz)
      const yaw = Math.atan2(siny_cosp, cosy_cosp)

      // 弧度转角度
      const radToDeg = 180 / Math.PI
      return {
        x: Number((roll * radToDeg).toFixed(2)),
        y: Number((pitch * radToDeg).toFixed(2)),
        z: Number((yaw * radToDeg).toFixed(2))
      }
    },
    // 获取节点初始位置和旋转
    async getNodePosRoat(isFirstTime) {
      const nodeInfo = await this.player.Native.Node.getProperty(this.activeNode, ['name', 'code', 'localTrans', 'localRot'])
      const data = await this.quaternionToEuler(nodeInfo.localRot[0], nodeInfo.localRot[1], nodeInfo.localRot[2], nodeInfo.localRot[3])
      if (isFirstTime) {
        this.originalData = {
          xPosition: nodeInfo.localTrans[0],
          yPosition: nodeInfo.localTrans[1],
          zPosition: nodeInfo.localTrans[2],
          xRotation: data.x,
          yRotation: data.y,
          zRotation: data.z
        }
      } else {
        this.settigOptions = {
          xPosition: nodeInfo.localTrans[0],
          yPosition: nodeInfo.localTrans[1],
          zPosition: nodeInfo.localTrans[2],
          xRotation: data.x,
          yRotation: data.y,
          zRotation: data.z
        }
      }
    },
    async startEdit(name) {
      this.isStartEdit = true
      if (this.activeNode) {
        await this.player.Native.Node.addNodeToAxisEdit(this.activeNode)
      }
      this.player.Native.Node.EventAxisEditFinish.connect(this.handleEditFinish)
    },
    async editNode(type) {
      await this.player.Native.Node.setAxisEditType(type)
    },
    handleEditFinish(data) {
      this.getNodePosRoat(false)
    }
  },
  async beforeDestroy() {
    await this.player.Native.Node.removeNodeFromAxisEdit(this.activeNode)
  },
}
</script>

<style lang="scss" scoped>
.action-config {
  .settings-wrap {
    ::v-deep .el-input__inner {
        background: url('../../../assets/images/cockpitNew/input-bg.png') no-repeat !important;
        background-size: 100% 100% !important;
        border: none !important;
        border-radius: unset !important;
      }

    .settings-wrap-item {
      .axis-name {
        width: 25%;
        text-align: center;
        color:#fff;
      }
    }
  }

  ::v-deep .el-table .cell.el-tooltip {
    color: #44f1ff !important
  }

  .bottom-content {
    ::v-deep .el-input__inner {
        width: 80px;
        background: url('../../../assets/images/cockpitNew/input-bg.png') no-repeat !important;
        background-size: 100% 100% !important;
        border: none !important;
        border-radius: unset !important;
      }
  }

}


</style>
